import { useNavigate } from 'react-router'

import { usePageTitle } from '../../hooks/usePageTitle'
import { widgetURL } from '../../utils/urls'
import { PSApplication } from '../app/PSApplication'
import { WorkflowPage } from '../workflows/WorkflowPage'

export function SetupOnboardingSuccessPage() {
    usePageTitle('Onboarding complete')
    const user = PSApplication.me()

    const navigate = useNavigate()

    return (
        <WorkflowPage onClose={() => navigate('/')}>
            <div className="flex h-full flex-col items-stretch justify-center">
                <WorkflowPage.SuccessView
                    title="Congratulations!"
                    showConfetti
                    subtitle="You're on your way!"
                    showLinksAsSingleColumn
                    links={[
                        {
                            id: 'go-live',
                            title: 'Go Live!',
                            subtitle:
                                'Grow your business on PocketSuite with just a few quick steps',
                            icon: 'pocketsuite.large',
                            to: '/golive/welcome',
                        },
                        {
                            id: 'preview',
                            title: 'Preview my booking site',
                            subtitle: 'Preview what your clients will see when booking you online',
                            icon: 'monitor.large',
                            onClick: () => {
                                window?.open(widgetURL({ user }), '_ps-web-booking')
                            },
                        },
                        {
                            id: 'dashboard',
                            title: 'Dashboard',
                            subtitle: 'View your PocketSuite dashboard',
                            icon: 'home.large',
                            to: '/',
                        },
                    ]}
                />
            </div>
        </WorkflowPage>
    )
}
